export default "__VITE_ASSET__TChhnpLw__"